import { ArrowPathIcon, DocumentArrowUpIcon } from '@heroicons/react/24/outline';
import { Alert } from 'components/Display/Alert';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReplaceConfirmationModal } from './ReplaceConfirmationModal/ReplaceConfirmationModal';

type UploadedFileAlertProps = {
  uploadedFileName: string | undefined;
  onUploadNewFile: () => void;
};
export const UploadedFileAlert: FC<UploadedFileAlertProps> = ({ uploadedFileName, onUploadNewFile }) => {
  const { t } = useTranslation();
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);

  const onConfirm = () => {
    onUploadNewFile();
    setConfirmationDialogOpen(false);
  };
  return uploadedFileName ? (
    <>
      <ReplaceConfirmationModal
        open={confirmationDialogOpen}
        onCancel={() => setConfirmationDialogOpen(false)}
        onConfirm={onConfirm}
      />
      <Alert
        severity="neutral"
        actions={{
          alignment: 'right',
          primary: {
            children: t('webedi:uploaded_file_alert.cta'),
            analyticsId: 'webedi:uploaded_file_alert.cta',
            LeftIcon: ArrowPathIcon,
            onClick: () => setConfirmationDialogOpen(true),
          },
        }}
      >
        <div className="flex items-center gap-2">
          <DocumentArrowUpIcon className="size-5 text-neutral-500" />
          <span>
            {t('webedi:uploaded_file_alert.text', {
              fileName:
                uploadedFileName.length > 50
                  ? uploadedFileName.includes('.')
                    ? `${uploadedFileName.substring(0, 45)}(...)${uploadedFileName.substring(
                        uploadedFileName.lastIndexOf('.'),
                      )}`
                    : `${uploadedFileName.substring(0, 45)}(...)`
                  : uploadedFileName,
            })}
          </span>
        </div>
      </Alert>
    </>
  ) : null;
};
